module.exports = __webpack_public_path__ + "static/media/p1.820406e0.png";